var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.283,
    height: 459.452,
    viewBox: "0 0 800.283 459.452",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.001 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.918 441.564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.278,312.134h0a12.465,12.465,0,0,0-5.2-3.049L436.759,293.47l-7.552,7.24,15.349,15.064a12.238,12.238,0,0,0,3.26,5.033c3.674,3.511,8.544,4.415,10.88,2.017s1.263-7.179-2.4-10.684h-.014Z",
    transform: "translate(-327.646 -170.988)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.059,270.541l-7.607,9.563-39.318-29.762-.034-.068L445.124,207.4a14.706,14.706,0,1,1,26.7-12.2l14.908,39.019,28.329,36.309Z",
    transform: "translate(-392.397 -136.424)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.754,164.58h16.029v25.429L515.11,184.2Z",
    transform: "translate(-458.837 -129.638)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.619,140.7a17.6,17.6,0,1,1-17.6-17.6A17.6,17.6,0,0,1,527.619,140.7Z",
    transform: "translate(-438.256 -116.33)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.612,148.761l-1.718,3.26-7.58-14.405c-4.564-13.978,11.376-22.005,11.376-22.005,5.2-6.126,15.655,1.039,15.655,1.039,15.078-3.348,7.8,9.359,7.8,9.359S527,126.124,527,130.28s-5.6,3.871-5.6,3.871l-4.388,7.682-2.425-2.948C505.573,135.068,506.612,148.761,506.612,148.761Z",
    transform: "translate(-447.31 -113.133)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.222,
    height: 20.178,
    transform: "translate(51.423 295.497)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.326,585.018c-6.242,0-15.356-.652-15.424-.659-2.438.217-14.609,1.175-15.214-1.61a11.96,11.96,0,0,1,.38-5.6c1.175-11.634,1.61-11.77,1.868-11.845.414-.122,1.623.455,3.586,1.718l.122.081.027.143c.034.177.9,4.449,5.026,3.8,2.825-.448,3.742-1.073,4.034-1.379a1.738,1.738,0,0,1-.747-.625,2.185,2.185,0,0,1-.156-1.82,28.807,28.807,0,0,1,2.187-4.91l.183-.326,16.164,10.908,9.984,2.853a2.555,2.555,0,0,1,1.664,1.474h0a2.575,2.575,0,0,1-.652,2.907c-1.813,1.63-5.42,4.422-9.2,4.768-1.005.1-2.336.129-3.831.129h0Z",
    transform: "translate(-437.832 -257.131)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.222,
    height: 20.178,
    transform: "matrix(-0.771, -0.637, 0.637, -0.771, 19.411, 289.863)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.468,550.994c-4.809-3.98-11.417-10.29-11.465-10.337-2.017-1.379-12.008-8.4-10.7-10.935a11.851,11.851,0,0,1,3.865-4.075c8.32-8.225,8.734-8.048,8.986-7.94.4.17.964,1.379,1.671,3.606l.041.136-.068.129c-.1.163-2.146,4.014,1.447,6.133,2.465,1.453,3.566,1.555,3.987,1.508a1.733,1.733,0,0,1-.177-.964,2.19,2.19,0,0,1,1.039-1.5,28.9,28.9,0,0,1,4.815-2.391l.346-.136,5.5,18.7,5.875,8.564a2.577,2.577,0,0,1,.34,2.2h0a2.583,2.583,0,0,1-2.357,1.827c-2.431.1-6.989-.048-10.12-2.187-.829-.571-1.875-1.392-3.029-2.343h0Z",
    transform: "translate(-568.188 -242.919)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.479,319.1,519.8,480.358H503.54L492.7,319.1h48.786Z",
    transform: "translate(-452.32 -179.211)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.077,407.183,492.7,449.19l13.855,11.444,55.564-52.847,4.965-88.688-9.936,8.884Z",
    transform: "translate(-477.918 -179.211)",
    fill: "#2f2e43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.992,177.582l9.936,94.861H497.143l-3.783-30.787a88.842,88.842,0,0,1,11.057-54.905L511.9,173.67l24.091,3.912h0Z",
    transform: "translate(-456.763 -132.554)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.414,346.939h0a12.427,12.427,0,0,0-3.464-4.931L509.4,321.85l-9.882,3.457,7.709,20.07a12.168,12.168,0,0,0,.876,5.936c1.881,4.714,5.943,7.559,9.06,6.35s4.123-6.011,2.241-10.724Z",
    transform: "translate(-435.811 -180.093)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.08,297.425l-10.887,5.542-23.425-43.393V259.5l-3.117-48.541a14.707,14.707,0,1,1,29.354,0l-2.628,41.681,10.7,44.792h0Z",
    transform: "translate(-461.01 -139.496)",
    fill: "#d6d6e3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M656.482,526.506H144.27c-4.774,0-8.644-3.443-8.649-7.686v-345c.006-4.243,3.875-7.681,8.649-7.686H656.482c4.775,0,8.644,3.443,8.649,7.686v345C665.125,523.063,661.256,526.5,656.482,526.506ZM144.27,167.84c-3.713,0-6.723,2.678-6.727,5.978v345c0,3.3,3.014,5.974,6.727,5.978H656.482c3.713,0,6.723-2.678,6.727-5.978v-345c0-3.3-3.014-5.974-6.727-5.978Z",
    transform: "translate(695.152 143.868)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.538,260.221H196.27a8.659,8.659,0,0,1-8.649-8.649V221.781a8.659,8.659,0,0,1,8.649-8.649H608.538a8.659,8.659,0,0,1,8.649,8.649v29.791a8.659,8.659,0,0,1-8.649,8.649ZM196.27,215.054a6.735,6.735,0,0,0-6.727,6.727v29.791a6.735,6.735,0,0,0,6.727,6.727H608.538a6.735,6.735,0,0,0,6.727-6.727V221.781a6.735,6.735,0,0,0-6.727-6.727Z",
    transform: "translate(693.289 129.81)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.64,343.221H196.27a8.659,8.659,0,0,1-8.649-8.649V304.781a8.659,8.659,0,0,1,8.649-8.649H359.64a8.659,8.659,0,0,1,8.649,8.649v29.791A8.659,8.659,0,0,1,359.64,343.221ZM196.27,298.054a6.735,6.735,0,0,0-6.727,6.727v29.791a6.735,6.735,0,0,0,6.727,6.727H359.64a6.735,6.735,0,0,0,6.727-6.727V304.781a6.735,6.735,0,0,0-6.727-6.727Z",
    transform: "translate(693.289 138.798)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.64,343.221H455.27a8.659,8.659,0,0,1-8.649-8.649V304.781a8.659,8.659,0,0,1,8.649-8.649H618.64a8.659,8.659,0,0,1,8.649,8.649v29.791a8.659,8.659,0,0,1-8.649,8.649ZM455.27,298.054a6.735,6.735,0,0,0-6.727,6.727v29.791a6.734,6.734,0,0,0,6.727,6.727H618.64a6.735,6.735,0,0,0,6.727-6.727V304.781a6.735,6.735,0,0,0-6.727-6.727Z",
    transform: "translate(683.188 138.798)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.343,540.04H511.789a8.178,8.178,0,0,1-8.168-8.169V521.3a8.178,8.178,0,0,1,8.168-8.168H621.343a8.178,8.178,0,0,1,8.168,8.168v10.571A8.178,8.178,0,0,1,621.343,540.04Z",
    transform: "translate(528.053 97.513)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.309,396.508A7.688,7.688,0,1,1,223,388.82a7.688,7.688,0,0,1-7.688,7.688Zm0-13.454a5.766,5.766,0,1,0,5.766,5.766A5.766,5.766,0,0,0,215.309,383.054Z",
    transform: "translate(692.508 135.482)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.309,422.508A7.688,7.688,0,1,1,223,414.82a7.688,7.688,0,0,1-7.688,7.688Zm0-13.454a5.766,5.766,0,1,0,5.766,5.766A5.766,5.766,0,0,0,215.309,409.054Z",
    transform: "translate(692.508 134.469)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.309,448.508A7.688,7.688,0,1,1,223,440.82a7.688,7.688,0,0,1-7.688,7.688Zm0-13.454a5.766,5.766,0,1,0,5.766,5.766,5.766,5.766,0,0,0-5.766-5.766Z",
    transform: "translate(692.508 133.454)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.367,382.632a6.246,6.246,0,0,0,0,12.493H343.74a6.246,6.246,0,0,0,0-12.493Z",
    transform: "translate(690.25 135.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.367,408.632a6.247,6.247,0,0,0,0,12.493H343.74a6.246,6.246,0,0,0,0-12.493Z",
    transform: "translate(690.25 134.41)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.367,434.632a6.247,6.247,0,0,0,0,12.493H343.74a6.246,6.246,0,0,0,0-12.493Z",
    transform: "translate(690.25 133.527)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.809,396.508a7.688,7.688,0,1,1,7.688-7.688A7.688,7.688,0,0,1,474.809,396.508Zm0-13.454a5.766,5.766,0,1,0,5.766,5.766,5.766,5.766,0,0,0-5.766-5.766Z",
    transform: "translate(682.387 135.482)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.809,422.508a7.688,7.688,0,1,1,7.688-7.688,7.688,7.688,0,0,1-7.688,7.688Zm0-13.454a5.766,5.766,0,1,0,5.766,5.766,5.766,5.766,0,0,0-5.766-5.766Z",
    transform: "translate(682.387 134.469)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.809,448.508a7.688,7.688,0,1,1,7.688-7.688A7.688,7.688,0,0,1,474.809,448.508Zm0-13.454a5.766,5.766,0,1,0,5.766,5.766,5.766,5.766,0,0,0-5.766-5.766Z",
    transform: "translate(682.387 133.669)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.867,382.632a6.246,6.246,0,1,0,0,12.493H602.24a6.246,6.246,0,1,0,0-12.493Z",
    transform: "translate(680.848 135.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.867,408.632a6.247,6.247,0,1,0,0,12.493H602.24a6.246,6.246,0,1,0,0-12.493Z",
    transform: "translate(680.848 134.41)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.867,434.632a6.247,6.247,0,1,0,0,12.493H602.24a6.246,6.246,0,1,0,0-12.493Z",
    transform: "translate(680.848 133.527)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494,314.132a6.246,6.246,0,0,0,0,12.493H322.165a6.246,6.246,0,1,0,0-12.493Z",
    transform: "translate(692.445 138.096)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494,231.132a6.246,6.246,0,0,0,0,12.493H322.165a6.246,6.246,0,1,0,0-12.493Z",
    transform: "translate(692.445 129.107)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.984,316.456a.48.48,0,0,0-.416.721l4.079,7.064a.481.481,0,0,0,.832,0l4.079-7.064a.48.48,0,0,0-.416-.721Z",
    transform: "translate(687.17 138.006)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.494,314.132a6.246,6.246,0,0,0,0,12.493H581.165a6.246,6.246,0,0,0,0-12.493Z",
    transform: "translate(682.344 138.096)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.984,316.456a.48.48,0,0,0-.416.721l4.079,7.064a.481.481,0,0,0,.833,0l4.078-7.064a.48.48,0,0,0-.416-.721Z",
    transform: "translate(677.068 138.006)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.844,
    cy: 3.844,
    rx: 3.844,
    ry: 3.844,
    transform: "translate(1153.354 545.445)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.844,
    cy: 3.844,
    rx: 3.844,
    ry: 3.844,
    transform: "translate(903.975 570.562)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.05,733.1H742.512a.809.809,0,0,1,0-1.617H960.05a.809.809,0,0,1,0,1.617Z",
    transform: "translate(-181.703 36.347)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.343,540.04H511.789a8.178,8.178,0,0,1-8.168-8.169V521.3a8.178,8.178,0,0,1,8.168-8.168H621.343a8.178,8.178,0,0,1,8.168,8.168v10.571A8.178,8.178,0,0,1,621.343,540.04Z",
    transform: "matrix(0.819, -0.574, 0.574, 0.819, -8.102, 470.589)",
    fill: "#6c63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadRequest);
export default __webpack_public_path__ + "static/media/bad-request.6d65e40ce14e9cc91fed5efe564bf045.svg";
export { ForwardRef as ReactComponent };